"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonActions_de_de = void 0;
function commonActions_de_de() {
    return {
        "actions.close": "schließen",
        "actions.save": "speichern",
        "actions.cancel": "abbrechen",
        "actions.create": "erstellen",
        "actions.yes": "ja",
        "actions.no": "nein",
        "actions.dialogdismiss": "schließen",
        "actions.add": "hinzufügen",
        "actions.edit": "bearbeiten",
        "actions.delete": "löschen",
        "actions.ok": "ok",
        "actions.search": "suchen",
        "actions.reset": "zurücksetzen",
        "actions.skip": "überspringen",
        "actions.print": "drucken",
        "actions.refresh": "aktualisieren",
        "actions.select": "auswählen",
        "actions.done": "fertig",
        "actions.more": "mehr",
        "actions.enable": "aktivieren",
        "actions.disable": "deaktivieren",
        "actions.accept": "akzeptieren",
        "actions.download": "herunterladen",
        "actions.upload": "hochladen",
        "actions.showall": "alle anzeigen",
        "actions.submit": "absenden",
        "actions.addnote": "Notiz hinzufügen",
        "actions.learn": "Mehr erfahren!",
        "actions.continue": "fortfahren",
        "actions.disconnect": "trennen",
        "actions.open": "öffnen",
        "actions.donotshowagain": "Nicht mehr anzeigen!",
        "actions.import": "importieren",
        "actions.check": "überprüfen",
        "actions.openinnewwindow": "In neuem Fenster öffnen",
        "actions.restore": "Wiederherstellen"
    };
}
exports.commonActions_de_de = commonActions_de_de;
